import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { get } from 'lodash';

import { TRANSACTION_TYPE_MAP } from '../../constants/constants';
import PageHeader from '../../modules/page-header';
import TransactionsDetailsComponent from '../../modules/transaction-details';
import { TransactionHistorySearch } from '../../services/api/dto/Transactions';
import { getTransaction } from '../../store/actions/transactions-history';
import { RootState } from '../../types';
import { TRANSACTION_TYPE } from '../../types';

import './transaction-details.scss';

const TransactionDetails: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const id = history.location.state?.id;
  const transaction = useSelector(
    (state: RootState) =>
      state.transactionsHistory.data.transaction as TransactionHistorySearch
  );

  useEffect(() => {
    id && dispatch(getTransaction({ transactionId: id }));
  }, [id]);

  return (
    <div className="container">
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <PageHeader
            items={[
              { link: '/history', title: 'Операции' },
              {
                link: '',
                title:
                  TRANSACTION_TYPE_MAP[
                    get(transaction, 'type') as Exclude<TRANSACTION_TYPE, null>
                  ],
              },
            ]}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-19S col-lg-27 col-xl-35">
          <div className="history-table-wrapper">
            {transaction && <TransactionsDetailsComponent data={transaction} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;
